import React from "react";
import * as FaIcons from "react-icons/fa";

import educationLevels from "../../../data/educationLevels";
import phoneTypes from "../../../data/phoneTypes";
import relationshipList from "../../../data/relationshipList";

const R3ParentInformation = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    registerForIntercession,
    firstName,
    age,
    pgHighestLevelOfEducation,
    permissionParentContact,
    pgRelationshipToStudent,
    pgFirstName,
    pgLastName,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    pgPrimaryEmail,
  } = formData;

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  return (
    <>
      {/* Parent/Guardian Information */}
      <div className="sub-form">
        <h3>Parent Information</h3>
        {!registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the Student" : firstName}'s
                  Parent/Guardian's Highest Level of Education?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pgHighestLevelOfEducation"
                value={pgHighestLevelOfEducation}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pgHighestLevelOfEducation !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {educationLevels.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </>
        )}
        {age >= 18 && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Do we have Permission to Contact{" "}
                  {firstName === "" ? "the Student" : firstName}'s  Parent/Guardian about School?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !(
                      permissionParentContact["yes"] ||
                      permissionParentContact["no"]
                    )
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={permissionParentContact["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="permissionParentContact"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={permissionParentContact["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="permissionParentContact"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </>
        )}

        {(permissionParentContact["yes"] || age < 18) && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is the Parent/Guardin's Relationship to{" "}
                  {firstName === "" ? "the Student" : firstName}?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pgRelationshipToStudent"
                value={pgRelationshipToStudent}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pgRelationshipToStudent !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {relationshipList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the Student" : firstName}'s{" "}
                  {pgRelationshipToStudent === ""
                    ? "Parent/Guardian"
                    : pgRelationshipToStudent}
                  's First Name?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgFirstName"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pgFirstName}
                style={{
                  border:
                    validationCheck && !(pgFirstName !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the Student" : firstName}'s{" "}
                  {pgRelationshipToStudent === ""
                    ? "Parent/Guardian"
                    : pgRelationshipToStudent}
                  's Last Name?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgLastName"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pgLastName}
                style={{
                  border:
                    validationCheck && !(pgLastName !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is{" "}
                  {pgFirstName === "" ? "the Parent/Guardian" : pgFirstName}'s
                  Email?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgPrimaryEmail"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                value={pgPrimaryEmail}
                style={{
                  border:
                    validationCheck &&
                    (pgPrimaryEmail === "" || !validateEmail(pgPrimaryEmail))
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
              {validationCheck && !validateEmail(pgPrimaryEmail) && (
                <p className="validEmail">
                  Please provide a valid email address
                </p>
              )}
            </div>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is{" "}
                  {pgFirstName === "" ? "the Parent/Guardian" : pgFirstName}'s
                  Primary Phone Number?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <input
                type="text"
                name="pgPrimaryPhone"
                onChange={(e) => {
                  onFormDataChange(e);
                }}
                placeholder="XXX-XXX-XXXX"
                value={pgPrimaryPhone}
                style={{
                  border:
                    validationCheck &&
                    (pgPrimaryPhone === "" || !validatePhone(pgPrimaryPhone))
                      ? "2px solid #d8302f"
                      : "",
                }}
              />
              {validationCheck && !validatePhone(pgPrimaryPhone) && (
                <p className="validEmail">
                  Please provide a valid phone number in the following format
                  XXX-XXX-XXXX
                </p>
              )}
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is{" "}
                  {pgFirstName === "" ? "the Parent/Guardian" : pgFirstName}'s
                  Primary Phone Type ?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="pgPrimaryPhoneType"
                value={pgPrimaryPhoneType}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(pgPrimaryPhoneType !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {phoneTypes.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default R3ParentInformation;
